import { useParams } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers'
import { Button, useModal } from 'app/components'
import { useFormularioAtual } from '../../../formularios-create/core/useFormularioAtual'
import { TiposAtendimentoVinculoModal } from '../modal/TiposAtendimentoVinculoModal'

export const TiposAtendimentoVinculosListToolbar = () => {
  const { showModal } = useModal()
  const { id: formularioId } = useParams()
  const { data: formulario } = useFormularioAtual()

  const createVinculo = () =>
    showModal({
      title: formulario?.nome ? `Novo vínculo — ${formulario.nome}` : 'Novo vínculo',
      content: <TiposAtendimentoVinculoModal formularioId={Number(formularioId)} />,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={createVinculo}>
      Novo vínculo
    </Button>
  )
}
